module.exports = "/static/media/drop.54cfec62.svg";